import PropTypes from 'prop-types'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@components/ui/select'
import { Label } from '@components/ui/label'
import { cn } from 'lib/utils'

export const AdasSearchMenu = ({
  options = [],
  value,
  onChange,
  disabled,
  className,
  placeholder = 'Select...',
  name,
  id,
  label,
  helperText,
  error,
  // eslint-disable-next-line no-unused-vars
  sx,
  // eslint-disable-next-line no-unused-vars
  SelectProps,
  // eslint-disable-next-line no-unused-vars
  InputProps,
  // eslint-disable-next-line no-unused-vars
  InputLabelProps,
  // eslint-disable-next-line no-unused-vars
  variant,
  ...rest
}) => {
  const handleChange = (selected) => {
    // Restore the original key type (may be numeric) before emitting
    const original = options.find((o) => String(o.value) === selected)
    const resolvedValue = original !== undefined ? original.value : selected
    if (onChange) onChange({ target: { name, id, value: resolvedValue } })
  }

  return (
    <div className='flex flex-col gap-1'>
      {label && (
        <Label htmlFor={id} className='text-xs font-medium text-text-primary'>
          {label}
        </Label>
      )}
      <Select value={value != null ? String(value) : undefined} onValueChange={handleChange} disabled={disabled} {...rest}>
        <SelectTrigger id={id} className={cn('w-full border-custom-borderInput', error && 'border-error', className)}>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {options.map((option) => (
            <SelectItem key={option.value} value={String(option.value)}>
              {option.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {helperText && <p className={cn('text-xs', error ? 'text-error' : 'text-text-secondary')}>{helperText}</p>}
    </div>
  )
}

AdasSearchMenu.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
      name: PropTypes.node.isRequired
    })
  ).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.node,
  helperText: PropTypes.node,
  error: PropTypes.bool
}
